export const buildProposalHistoryPreviewPath = (proposalId: string, revisionId: string): string => {
  return `/proposals/${proposalId}/history/${revisionId}/public-preview`;
};
